/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Category_TitleInputs */

const en_directory_taxonomy_index_category_title = /** @type {(inputs: Directory_Taxonomy_Index_Category_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse every sub-category`)
};

const zh_directory_taxonomy_index_category_title = /** @type {(inputs: Directory_Taxonomy_Index_Category_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览全部子分类`)
};

/**
* | output |
* | --- |
* | "Browse every sub-category" |
*
* @param {Directory_Taxonomy_Index_Category_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_category_title = /** @type {((inputs?: Directory_Taxonomy_Index_Category_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Category_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_category_title(inputs)
	return zh_directory_taxonomy_index_category_title(inputs)
});
export { directory_taxonomy_index_category_title as "directory.taxonomy_index.category.title" }